// extracted by mini-css-extract-plugin
module.exports = {"FilmInformationList":"FilmInformationList_FilmInformationList__2um-1","Title":"FilmInformationList_Title__ISC1a"};